module.exports = __webpack_public_path__ + "img/guang.ebfd2ad9.png";